/* unplugin-vue-components disabled */import { render } from "./Tip.vue?vue&type=template&id=90e4a2fa"
import script from "./Tip.vue?vue&type=script&lang=js"
export * from "./Tip.vue?vue&type=script&lang=js"

import "./Tip.vue?vue&type=style&index=0&id=90e4a2fa&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__